const DataValidator = function (payload) {
    console.log("payload---", payload)
    this.clusterlets = payload.clusterlets;
    this.sections = payload.sections;
    this.views = payload.views;
    this.fields = payload.fields;
    this.events = payload.events;
    this.validationErrors = [];
}

DataValidator.prototype.generateErrorObject = function (feature, featureEntity, errorType, type, item, construct, constructName, focusObject) {
    let errorObj = { feature, featureEntity, errorType, type, item, construct, constructName, focusObject };
    this.validationErrors.push(errorObj);
}

DataValidator.prototype.validateNestedFields = function (viewName, clusterlet, parentId, fieldPath, child) {
    if (this.fields !== undefined) {
        for (let i = 1; i < fieldPath.length; i++) {
            let field = this.fields.find(field => field.name === fieldPath[i] && field.parent[0].id == parentId);

            if (field === undefined) {
                let construct = clusterlet.type === 2 ? 'clusterlet' : 'analytics';
                let focusObject = { ...child };
                this.generateErrorObject('view', viewName, 'warning', 'missing', `${fieldPath.join(".")}`, construct, clusterlet.name, focusObject)
                return;
            }
            parentId = field._id;
        }
    }
}

DataValidator.prototype.validateNestedStructure = function (children, viewName) {
    let clusterletIds = this.clusterlets.map(clusterlet => clusterlet._id);
    children.forEach(child => {
        if (child.hasOwnProperty("mapping") &&
            child.mapping.hasOwnProperty("clusterlet") &&
            !clusterletIds.includes(child.mapping.clusterlet)) {
            let focusObject = { ...child };
            this.generateErrorObject('view', viewName, 'warning', 'missing', 'clusterlet', undefined, undefined, focusObject);
            return;
        }
        this.validateNestedStructure(child.children, viewName);
    });

}

DataValidator.prototype.validateEvents = function (children, viewName) {
    let eventIds = this.events.map(event => event._id);
   
    children.forEach(child => {
        if (child.hasOwnProperty("mapping") &&
            child.mapping.hasOwnProperty("event") &&
            !eventIds.includes(child.mapping.clusterlet)) {
            let focusObject = { ...child };
            this.generateErrorObject('view', viewName, 'warning', 'missing', 'event', undefined, undefined, focusObject);
            return;
        }
        this.validateEvents(child.children, viewName);
    });

}

DataValidator.prototype.recursiveLoop = function (array, clusterlet, viewName) {
    array.forEach(child => {
        if (child.hasOwnProperty("mapping") &&
            child.mapping.hasOwnProperty("clusterlet") &&
            child.mapping.clusterlet == clusterlet?._id) {
            let fieldPath = child.mapping.field?.split(".");
            if (fieldPath?.length > 0) {
                let sectionsOfselectedClusterlet = this.sections.filter(section => section?.parent[0]?.id == clusterlet.id);

                let sectionNames = sectionsOfselectedClusterlet.map(ele => ele.name);
                if (sectionNames.includes(fieldPath[0])) {
                    let sectionData = sectionsOfselectedClusterlet.find(e => e.name === fieldPath[0]);
                    this.validateNestedFields(viewName, clusterlet, sectionData._id, fieldPath, child);  
                }
            }
        }
        this.recursiveLoop(child.children, clusterlet, viewName);
    });
}


DataValidator.prototype.iterateViews = function (array, clusterlet, viewName) {
    array.forEach(child => {
        if (child.hasOwnProperty("mapping") &&
            child.mapping.hasOwnProperty("clusterlet") &&
            child.mapping.clusterlet == clusterlet?._id) {
            let fieldPath = child.mapping.field?.split(".");
            if (fieldPath?.length > 0) {
                let sectionsOfselectedClusterlet = this.sections.filter(section => section?.parent[0]?.id == clusterlet._id);
                let sectionNames = sectionsOfselectedClusterlet.map(ele => ele.name);
                console.log('secnames----', sectionNames)
                if (!sectionNames.includes(fieldPath[0])) {
                    console.log('secnames----', sectionNames)

                    let construct = clusterlet.type === 2 ? 'clusterlet' : 'analytics';
                    let focusObject = { ...child };
                    this.generateErrorObject('view', viewName, 'warning', 'missing', `${fieldPath.join(".")}`, construct, clusterlet.name, focusObject);
                }
            }
        }
        this.iterateViews(child.children, clusterlet, viewName);
    });
}

DataValidator.prototype.validateMisssingClusterlets = function () {
    this.views.forEach(view => {
        let validationResult = this.validateNestedStructure(view.schema, view.name);
    });
    console.log("this.validationErrors---", this.validationErrors)
}

DataValidator.prototype.validateMisssingClusterletFields = function () {
    this.clusterlets.forEach(clusterlet => {
        this.views.forEach(view => {
            this.recursiveLoop(view.schema, clusterlet, view.name);
        });
    });
    console.log("validationErrors---", this.validationErrors)
}

DataValidator.prototype.validateMisssingClusterletSections = function () {
    this.clusterlets.forEach(clusterlet => {
        this.views.forEach(view => {
            this.iterateViews(view.schema, clusterlet, view.name);
        });
    });
    console.log("validationErrors---", this.validationErrors)
}

DataValidator.prototype.validateMisssingEvents = function () {
    this.views.forEach(view => {
        let validationResult = this.validateEvents(view.schema, view.name);
    });
    console.log("validationErrors---", this.validationErrors)
}

DataValidator.prototype.validateViewMapping = function () {
    this.validateMisssingClusterlets();
    this.validateMisssingClusterletSections();
    this.validateMisssingClusterletFields();
    console.log("validationErrors---", this.validationErrors)

}

export default DataValidator;